<template>
  <div :class="`${arabic ? 'arFont' : 'enFont'}`">
    <v-row dense>
      <v-col v-for="document in documents" cols="12" md="4">
        <v-card class="pa-3">
          <v-chip :color="rand_color()" small dark class="text-capitalize">
            {{ document_type(document) }}
          </v-chip>
          <div class="mt-2">
            <span class="d-inline-block text-truncate" style="max-width: 100%; direction: ltr;">{{
              document.url
            }}</span>
            <v-btn dark v-clipboard:copy="document.url" color="indigo darken-1" x-small>
              {{ i18n.copy }}
              <v-icon size="14" class="mr-1">link</v-icon>
            </v-btn>
            <v-btn link :href="document.url" target="_blank" dark color="blue darken-1" x-small class="mr-1">
              {{ i18n.open }}
              <v-icon size="14" class="mr-1">open_in_new</v-icon>
            </v-btn>
          </div>
          <div class="mt-2">
            <span class="ml-2">
              {{ formatDateToCurrentLocale(document.created_at)[0] }}
            </span>
            <span>
              {{ formatDateToCurrentLocale(document.created_at)[1] }}
            </span>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    documents: Array,
    types: Array,
  },
  data() {
    return {
      colors: [
        "blue darken-2",
        "light-blue darken-2",
        "green darken-2",
        "teal darken-2",
        "indigo darken-2",
        "red darken-2",
      ],
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    language() {
      return this.$store.state.language;
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar") return true;
    },
  },
  methods: {
    document_type(document) {
      return this.types.find((type) => type.slug == document.type).ar;
    },
    formatDateToCurrentLocale(date) {
      let new_date = new Date(date);
      return [
        new_date.toLocaleDateString(this.arabic ? "ar" : "en", {
          day: "numeric",
          year: "numeric",
          month: "short",
        }),
        new_date.toLocaleTimeString(this.arabic ? "ar" : "en"),
      ];
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
    rand_color() {
      return this.colors[this.rnd(0, this.colors.length - 1)];
    },
  },
};
</script>
